<script lang="ts">
  // The opt-in for showing on other riders' group reports (User::showsOnGroupReports), on the
  // Activity Reports and Strava Sync pages. Off by default: riders show as anonymous.
  import SettingSwitch from '@/Common/SettingSwitch.svelte'
  import { saveGroupReportPrivacy } from '@/Util/api'
  import { ErrorCode } from '@/Util/errorCodes'
  import { notifyApiError } from '@/Util/notify'

  export let checked = false
  export let id = 'show-on-group-reports'

  async function save(show: boolean) {
    const res = await saveGroupReportPrivacy(show)
    if (!res.success) notifyApiError(res, { code: ErrorCode.GROUP_REPORT_PRIVACY_FAILED, message: 'Could not save your group report setting. Please try again.' })
    return !!res.success
  }
</script>

<SettingSwitch {id} bind:checked {save}
  label="Show my name and photo on other riders' group reports"
  description="When this is off, you appear as an anonymous Xert rider on the report images of riders you rode with." />
